import React from "react";
import { Navigate } from "react-router-dom";
import useHasPermission from "./useHasPermission";

export function Permission({ children, required }) {
    if (!useHasPermission(required)) {
       return <Navigate to="/403" replace />; 
    }
    return <>{children}</>;
}
export default Permission;


